import { NavItem, NavLink } from "reactstrap"
import cn from 'classnames'
import React from "react"

interface TabButtonProps {
    label?: string, 
    children?: React.ReactElement | string, 
    active: boolean, 
    setActive: () => void,
}

const TabButton: React.FC<TabButtonProps> = ({label, children, active, setActive}): React.ReactElement => (
    <NavItem>
        <NavLink
            className={cn({active})}
            onClick={() => !active && setActive()}
        >
            {label ?? children}
        </NavLink>
    </NavItem>
)

export default TabButton